import Chart from 'chart.js/dist/chart.js';

export const constructChartData = (color, greyColor, cutout, spacing) => {
  return {
    datasets: [
      {
        data: [20, 80],
        backgroundColor: [greyColor, color],
        spacing,
        cutout,
        hoverBackgroundColor: color,
        hoverOffset: 0
      }
    ]
  };
};

export const generateChart = (chartId, color, greyColor, cutout, spacing) => {
  const chartOptions = {
    responsive: true,
    maintainAspectRatio: true,
    cutoutPercentage: 60,
    legend: { display: false },
    animation: { duration: 2700 },
    tooltips: { enabled: false },
    hover: { mode: null },
    events: []
  };

  const canvas = document.getElementById(chartId).getContext('2d');
  const chartData = constructChartData(color, greyColor, cutout, spacing);

  return new Chart(canvas, {
    type: 'doughnut',
    data: chartData,
    options: chartOptions
  });
};
